module.exports = __webpack_public_path__ + "Unknown.7d14a14e10b98c8fe9bdb4ae233eb799.hashedasset.svg";